
import { Link } from 'react-router-dom';
import './BannerBlock.css'

const banners = [
    {
        heading: "Innovation",
        lists: [
            "Inventors of Multifiber",
            "R&D, Discovery Box, forward-facing relevance"
        ],
        link: "/innovation"
    },
    {
        heading: "Application",
        lists: [
            "Product use across industries: chemists, conservators, educators",
            "Case studies, certifications, workflows"
        ],
        link: "/application"
    },
    {
        heading: "Legacy",
        lists: [
            "Founder Werner Klaas, company history",
            "90+ year heritage, milestones"
        ],
        link: "/heritage"
    },
]


const BannerBlocks = () => {

    return (
        <div className="container mt-md-3 mt-2 mb-md-5 mb-3">
            <div className="intro-text">
                <p>Testfabrics is a family-owned company spanning three generations, trusted by chemists, conservators, designers, and educators for over 90 years. From the invention of the multifiber test fabric to today’s global testing solutions, we remain committed to helping you do your best work.</p>
            </div>
            <div className="banner-blocks-container d-flex flex-md-row flex-wrap flex-column g mt-5">
                {
                    banners.map((banner,index) => (
                        <div className="banner-block mx-3 mb-lg-0 mb-4" key={banner.heading+index}>
                            <div>
                                <h4>{banner.heading}</h4>
                            </div>
                            <ul className='d-flex flex-column align-items-center justify-content-center'>
                                {
                                    banner.lists.map((item,item_index) => 
                                        <li key={"list_item"+index+item_index}>{item}</li>
                                    )
                                }
                            </ul>
                            <div className='btn-group'>
                                <Link to={banner.link} className='header-btn'>Learn More</Link>
                            </div>
                        </div>
                    ))
                }
                
            </div>

        </div>
    );


}



export default BannerBlocks;